module.exports = __webpack_public_path__ + "c54cb7b12cbf2271f07bdd6903de631f.fbx";